export const FETCH_CONTROL_TOWER_REQUEST = 'FETCH_CONTROL_TOWER_REQUEST';
export const FETCH_CONTROL_TOWER_SUCCESS = 'FETCH_CONTROL_TOWER_SUCCESS';
export const FETCH_CONTROL_TOWER_FAILURE = 'FETCH_CONTROL_TOWER_FAILURE';
